import React, { useState } from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip, Button, Popover } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo, faPrint, faCalendarDay } from "@fortawesome/free-solid-svg-icons";
import PdfButton from "./Pdf/PdfButton";
import PdfMessengerButton from "./Pdf/PdfMessengerButton";
import PdfButtonSingleDay from "./Pdf/SingleDay/PdfButtonSingleDay";
import ExcelButton from "./Excel/ExcelButton";
import moment from "moment";

const HelpAndPrint = props => {
  const { establishment, activityTypes, categoriesFilter } = props;
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));

  // Met tous les types d'activité dans un tableau
  let allTypes = [];
  if (activityTypes.length > 0) {
    activityTypes.forEach(type => {
      allTypes = [...allTypes, type.value];
    });
  }

  return (
    <Container>
      <OverlayTrigger
        trigger="click"
        key={"pdf-top"}
        placement={"top"}
        overlay={
          <Popover id={`popover-positioned-top`}>
            <Popover.Title as="h3">
              Choisir la semaine de stock à générer
            </Popover.Title>
            <Popover.Content>
              <PdfButton
                establishmentId={establishment}
                types={allTypes}
                categoriesFilter={categoriesFilter}
              />
            </Popover.Content>
          </Popover>
        }
      >
        <Action variant="secondary">
          <FontAwesomeIcon icon={faCalendarDay} /> Semaine en PDF
        </Action>
      </OverlayTrigger>
      <OverlayTrigger
        trigger="click"
        key={"excel-top"}
        placement={"top"}
        overlay={
          <Popover id={`popover-excel-top`}>
            <Popover.Title as="h3">
              Choisir la semaine de stock à générer (Excel)
            </Popover.Title>
            <Popover.Content>
              <ExcelButton
                establishmentId={establishment}
                types={allTypes}
                categoriesFilter={categoriesFilter}
              />
            </Popover.Content>
          </Popover>
        }
      >
        <Action variant="secondary">
          <FontAwesomeIcon icon={faPrint} /> Semaine en Excel
        </Action>
      </OverlayTrigger>
      <OverlayTrigger
        trigger="click"
        key={"pdf-top"}
        placement={"top"}
        overlay={
          <Popover id={`popover-positioned-top`}>
            <Popover.Title as="h3">
              En test, nouveau systeme de génération pour éviter les crashs
            </Popover.Title>
            <Popover.Content>
              <PdfMessengerButton
                establishmentId={establishment}
                types={allTypes}
                categoriesFilter={categoriesFilter}
              />
            </Popover.Content>
          </Popover>
        }
      >
        <Action variant="secondary">
        <FontAwesomeIcon icon={faCalendarDay} /> Semaine V2
        </Action>
      </OverlayTrigger>
      <OverlayTrigger
        trigger="click"
        key={"pdf-single-day"}
        placement={"top"}
        overlay={
          <Popover id={`popover-single-day`}>
            <Popover.Title as="h3">
              Générer PDF pour une journée spécifique
            </Popover.Title>
            <Popover.Content>
              <DateSelector>
                <label htmlFor="date-selector">Sélectionner une date :</label>
                <input
                  id="date-selector"
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  style={{ margin: "10px 0", padding: "5px" }}
                />
                <PdfButtonSingleDay
                  establishmentId={establishment}
                  types={allTypes}
                  categoriesFilter={categoriesFilter}
                  selectedDate={selectedDate}
                />
              </DateSelector>
            </Popover.Content>
          </Popover>
        }
      >
        <Action variant="secondary">
          <FontAwesomeIcon icon={faCalendarDay} /> Jour
        </Action>
      </OverlayTrigger>
      <OverlayTrigger
        key={"doc-right"}
        placement={"right"}
        overlay={
          <Tooltip id={`tooltip-right`}>
            Voir la documentation sur les prévisionnels
          </Tooltip>
        }
      >
        <a
          href="https://moulindev.freshdesk.com/support/solutions/articles/48001080200-gestion-des-stocks"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Action variant="secondary">
            <FontAwesomeIcon icon={faInfo} />
          </Action>
        </a>
      </OverlayTrigger>
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  left: 1.5rem;
  bottom: 1.5rem;
  transition: 300ms;
`;

const Action = styled(Button)`
  background-color: ${props => props.theme.colors.favorite};
  height: 3rem;
  margin: 0 0.2rem;
  border: 2px solid ${props => props.theme.colors.favorite};
  &:hover {
    background-color: white;
    color: ${props => props.theme.colors.favorite};
    border: 2px solid ${props => props.theme.colors.favorite};
  }
`;

const DateSelector = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 250px;
  
  label {
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  input[type="date"] {
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }
`;

HelpAndPrint.propTypes = {
  establishment: PropTypes.string,
  activityTypes: PropTypes.array
};

export default HelpAndPrint;
